import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetProgramSearchProvider } from './context/budget-program-search-context';
import { BudgetProgramSearchComponent } from './budget-program-search-component';

export function BudgetProgramSearchFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetProgramSearchProvider>
                <BudgetProgramSearchComponent />
            </BudgetProgramSearchProvider>
        </BaseLayoutFactory>
    );
}
